import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingIcon from 'mdi-react/LoadingIcon';
import SequenceContactList from 'components/ContactList/SequenceContactList';
import { getSequenceContacts } from 'redux/actions/sequenceContactActions';
import { DEFAULT_CONTACT_QUERY_PARAMS } from 'constants/sequence';
import { Can } from 'utils/permissions';
import Index from './AddContactsModal';


class ContactsPreview extends Component {
  static propTypes = {
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    sequenceContacts: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
    getSequenceContacts: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalSize: 'large',
      addContactModalOpen: false,
    };
  }

  componentDidMount() {
    this.getSequenceContacts();
  }

  getSequenceContacts = (params = {}) => {
    const sequenceId = this.props.match.params.id;
    this.props.getSequenceContacts(sequenceId, {
      ...params,
      ...DEFAULT_CONTACT_QUERY_PARAMS,
      exlude_self: true,
    });
  }

  handleChangeModalSize = (size) => {
    this.setState({ modalSize: size });
  }

  toggle = () => this.setState({ addContactModalOpen: !this.state.addContactModalOpen });

  render() {
    const { sequenceContacts, sequence } = this.props;
    const { addContactModalOpen, modalSize } = this.state;
    const isLoading = sequenceContacts.loading || sequence.loading;

    return (
      <div>
        <Can I="add" a="Contact">
          <Index
            isOpen={addContactModalOpen}
            toggle={this.toggle}
            modalSize={modalSize}
            handleChangeModalSize={this.handleChangeModalSize}
          />
        </Can>
        {isLoading && <div className="loader"><LoadingIcon /></div>}
        <SequenceContactList
          onClickAddContact={this.toggle}
          getContacts={this.getSequenceContacts}
          sequence={sequence}
          contacts={sequenceContacts}
          showDuplicates={false}
          showDownloadErrors={false}
          showContactReplyForCurrentSequence
          showSteps
        />
      </div>
    );
  }
}


export default compose(connect(
  state => ({
    sequence: state.sequence,
    sequenceContacts: state.sequenceContacts,
  }),
  { getSequenceContacts },
))(ContactsPreview);
